export default __webpack_public_path__ + "static/media/cont4.a5d916e1.jpg";